import { render } from "./BoxFolderPickerComponent.vue?vue&type=template&id=85e4855c&scoped=true"
import script from "./BoxFolderPickerComponent.vue?vue&type=script&lang=js"
export * from "./BoxFolderPickerComponent.vue?vue&type=script&lang=js"

import "./BoxFolderPickerComponent.vue?vue&type=style&index=0&id=85e4855c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e4855c"]])

export default __exports__